import { CourseCard } from '@/components/ui/custom/coursePath/card/coursePathCard/CoursePathCard';
import { DesktopIcon } from '@/components/icons';
import useStudentContext from '@/data/hook/useStudentContext';
import { EnrollmentStatusEnum } from '@/models/Enrollment';
import { SimplifiedCourseProgress } from '@/models/StudentCourseProgress';
import { getBannerImg } from '@/utils/coursePath';
import { ROUTES } from '@/utils/routes';

type CourseProgressCardProps = {
  courseProgress: SimplifiedCourseProgress;
  onMutate?: (courseProgress: SimplifiedCourseProgress) => void;
};

export default function AsyncCourseProgressCard({
  courseProgress,
}: CourseProgressCardProps) {
  const { coursePath, progress } = courseProgress;

  const { dashboardStatsCollection, selectProgress } = useStudentContext();

  const thisProgress = dashboardStatsCollection.find(
    progress => progress.id === courseProgress.id,
  );

  const courseBannerImg = getBannerImg(coursePath);
  const courseName = coursePath.course.name;
  const totalLessons = thisProgress?.progresses.lessons.total || 0;
  const completedLessons = thisProgress?.progresses.lessons.completed || 0;
  const remainingLessons = totalLessons - completedLessons;

  const getCourseCardLink = () => {
    if (courseProgress.enrollmentStatus === EnrollmentStatusEnum.CANCELED) {
      return ROUTES.COURSES.INFO(coursePath.slug);
    }
    return ROUTES.COURSES.INFO(coursePath.slug, courseProgress.klassId);
  };

  return (
    <CourseCard
      to={getCourseCardLink()}
      onClick={() => selectProgress(courseProgress.id)}
    >
      <CourseCard.Header>
        <CourseCard.Image src={courseBannerImg} />
      </CourseCard.Header>
      <CourseCard.Body
        className={{
          base: 'flex flex-row gap-2 w-full items-center justify-between',
        }}
      >
        <div className="flex flex-row gap-2 w-full truncate">
          <CourseCard.Title text={courseName} />
          <CourseCard.ProgressIcon
            progress={progress}
            icon={<DesktopIcon className={'w-6 h-6 shrink-0 text-info'} />}
          />
        </div>
        <CourseCard.Formats formats={coursePath?.course?.formats} />
      </CourseCard.Body>

      <CourseCard.Footer className={{ base: 'flex flex-col gap-2 w-full' }}>
        <CourseCard.Progress value={progress} color="info" />
        <CourseCard.ProgressStats
          courseProgress={courseProgress}
          totalLessons={totalLessons}
          remainingLessons={remainingLessons}
          className={{ section: 'text-info' }}
        />
      </CourseCard.Footer>
    </CourseCard>
  );
}
